/**
 * Enhances every DateControl rendered with a picker configuration (DEVDV-683). Idempotent: a field already
 * enhanced carries data-date-picker-ready, so the call can be repeated after a snippet redraw.
 */
import {enhanceDateInput} from './dateProxy.js';

const SELECTOR = 'input[type=date][data-type=date][data-date-picker]:not([data-date-picker-ready])';

/**
 * @param {ParentNode} root
 */
export function initDatePickers(root = document) {
	root.querySelectorAll(SELECTOR).forEach((native) => {
		enhanceDateInput(native, JSON.parse(native.getAttribute('data-date-picker')));
	});
}
